// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_8Cq","cls2":"FilterPanel-cls2_bd- FilterPanel-cls1_8Cq"};